import { NgModule } from '@angular/core';

import { MembershipListTableModule } from '@app/src/app/shared/components/membership-list-table';
import { CommonUIModules } from '@app/src/app/shared/modules';

import { FtmRestrictionsComponent } from './ftm-restrictions.component';
import { FtmRestrictionsService } from './services/ftm-restrictions.service';

@NgModule({
  declarations: [FtmRestrictionsComponent],
  providers: [FtmRestrictionsService],
  imports: [
    // Minga dependencies
    CommonUIModules,
    MembershipListTableModule,

    // External dependencies
  ],
})
export class FtmRestrictionsModule {}
